
import { Navigate } from 'react-router';
import { useUserStore } from '../stores/useUserStore';

export const ProtectedRoute = ({ element }) => {
    const { user } = useUserStore.getState();
    if (!user || !user.token) {
        return <Navigate to="/login" />;
    }
    return element;
};

